import {
  Component,
  inject,
  signal,
} from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FluidModule } from 'primeng/fluid';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ApiService } from '../../../api.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  TAGInvTransaction,
} from '../../../../models/taginventory';
import { MessageService } from 'primeng/api';
import { SelectModule } from 'primeng/select';
import { TAGEvent } from '../../../../models/tagevent';

export interface TransactionCreateDialogData {
  eventid?: string;
  transactionName?: string;
}

@Component({
  selector: 'app-internal-transaction-create-dialog',
  imports: [
    SkeletonModule,
    InputTextModule,
    DialogModule,
    ButtonModule,
    FluidModule,
    ReactiveFormsModule,
    FloatLabelModule,
    TranslatePipe,
    SelectModule,
    FormsModule,
  ],
  providers: [DialogService, TranslateService],
  templateUrl: './transaction-create-dialog.html',
  styleUrl: './transaction-create-dialog.scss',
})
export class TransactionCreateDialog {
  //private dialogService = inject(DialogService);
  private translate = inject(TranslateService);
  private messageService = inject(MessageService);
  //private router = inject(Router);
  public api = inject(ApiService);
  //public printer = inject(PrinterService);

  events = signal<TAGEvent[]>([]);
  loadingEvents = signal(true);

  transactionForm = new FormGroup({
    location: new FormControl('', [Validators.required]),
    event: new FormControl(undefined, []),
  });


  constructor(
    public dialogRef: DynamicDialogRef<TransactionCreateDialog>,
    public config: DynamicDialogConfig<TransactionCreateDialogData>,
  ) {
    config.header = this.translate.translate('internal.inventory.transactionCreate.title')();

    if (config.data.transactionName) this.transactionForm.patchValue({location: config.data.transactionName});
    if (config.data.eventid) this.transactionForm.patchValue({event: config.data.eventid});
  }

  ngOnInit() {
    this.api.waitForAPI().then(() => {
      this.api
        .getEvents()
        .then((events: TAGEvent[]) => {
          events.sort((a, b) => {
            return a.startdate > b.startdate ? -1 : 1;
          });

          this.events.set(events);
          this.loadingEvents.set(false);
        })
        .catch((reason) => {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.translate('errors.couldNotLoadEvents')(),
            detail: reason.message,
          });
        });
    });
  }

  saveEdit(): void {
    if (!this.transactionForm.valid) return;

    let transaction = new TAGInvTransaction(this.transactionForm.value);
    this.dialogRef.close(transaction);
  }

}
